var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isChip)?_c('v-chip',{staticStyle:{"text-transform":"capitalize"},attrs:{"outlined":"","small":"","color":_vm.getClientStatusColor(_vm.type).background}},[_vm._v(" "+_vm._s(_vm.type)+" ")]):_c('div',{staticClass:"client-status"},[_c('span',{staticClass:"dot",style:(_vm.getClientStatusColor(_vm.type))}),_vm._v(" "+_vm._s(_vm.type)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }